import { MainVar } from "@/entity/MainVar";
import { General } from "./General";
import { DropDownItem, SelectDropDownItem } from "./DropDownItem";
import { ExcludedTypeOfProposalOption } from '@/entity/Net20/ExcludedTypeOfProposalOption';
import axios from 'axios';
import { PotentialVolumeLimitOption } from '@/entity/Net20/PotentialVolumeLimitOption';
import { SupplierRequestExclusion } from '@/entity/Net20/SupplierRequestExclusion';
import { ExcludedContractStep } from "@/entity/Net20/ExcludedContractStep";
import { PlannedSignInstallationDefault } from "@/entity/Net20/PlannedSignInstallationDefault";
import { FieldConfiguration } from "@/entity/Net20/FieldConfiguration";
import { District } from "@/entity/District";
import { ContractConfiguration } from "@/entity/Net20/ContractConfiguration";

export enum SOURCE {
    TYPE_OF_PROPOSAL = "TYPE_OF_PROPOSAL",
    DISTRIBUTOR = "DISTRIBUTOR",
    WORKSHOP_AREA = "WORKSHOP_AREA",
    TRAFFIC_FLOW = "TRAFFIC_FLOW", 
    WORKSHOP_VISIBILITY = "WORKSHOP_VISIBILITY",
    WORKSHOP_APPEARANCE = "WORKSHOP_APPEARANCE",
    TRAINING_TYPE = "TRAINING_TYPE",
    TRAINING_PERYEAR = "TRAINING_YEAR",
    CONSUMER_REVIEW = "CONSUMER_REVIEW",
    SERVICE = "CUSTOMER_SERVICE",
    FINANCIAL_RISK = "FINANCIAL_RISK",
    SIGN_CUSTOMIZATION = "SIGN_CUSTOMIZATION",
    SIGN_TYPE = "SIGN_TYPE",
    SIGN_SIZE = "SIGN_SIZE",
    SIGN_BRAND_CUSTOMIZATION = "SIGN_BRAND_CUSTOMIZATION",
    SIGN_HIGH_TRAFFIC_STREET = "SIGN_HIGH_TRAFFIC_STREET",
    SIGN_REPLACEMENT_TYPE = "SIGN_REPLACEMENT_TYPE",
    SIGN_REPLACEMENT_MODULES_PANELS = "SIGN_REPLACEMENT_MODULES_PANELS",
    SIGN_REPLACEMENT_MODULES_PLEXIGLASS = "SIGN_REPLACEMENT_MODULES_PLEXIGLASS",
    WELCOME_KIT_SIZE = "WELCOME_KIT_SIZE"
}

let TYPE_OF_PROPOSAL_LIST: Array<DropDownItem> = [];
let DISTRIBUTOR_LIST: Array<DropDownItem> = [];
let WORKSHOP_AREA_LIST: Array<DropDownItem> = [];
let TRAFFIC_FLOW_LIST: Array<DropDownItem> = [];
let WORKSHOP_VISIBILITY_LIST: Array<DropDownItem> = [];
let WORKSHOP_APPEARANCE_LIST: Array<DropDownItem> = [];
let TRAINING_TYPE_LIST: Array<DropDownItem> = [];
let TRAINING_PERYEAR_LIST: Array<DropDownItem> = [];
let CONSUMER_REVIEW_LIST: Array<DropDownItem> = [];
let SERVICE_LIST: Array<DropDownItem> = [];
let FINANCIAL_RISK_LIST: Array<DropDownItem> = [];
let SIGN_CUSTOMIZATION_LIST: Array<DropDownItem> = [];
let SIGN_TYPE_LIST: Array<DropDownItem> = [];
let SIGN_SIZE_LIST: Array<DropDownItem> = [];
let SIGN_BRAND_CUSTOMIZATION_LIST: Array<DropDownItem> = [];
let SIGN_HIGH_TRAFFIC_STREET_LIST: Array<DropDownItem> = [];
let SIGN_REPLACEMENT_TYPE_LIST: Array<DropDownItem> = [];
let WELCOME_KIT_SIZE_LIST: Array<DropDownItem> = [];

let DD_SIGN_REPLACEMENT_MODULES_PANELS: Array<DropDownItem> = [];
let DD_SIGN_REPLACEMENT_MODULES_PLEXIGLASS: Array<DropDownItem> = [];

let EXCLUDED_TYPE_OF_PROPOSAL_OPTIONS: Array<ExcludedTypeOfProposalOption> = [];
let POTENTIAL_VOLUME_LIMIT_OPTIONS: Array<PotentialVolumeLimitOption> = [];
let SUPPLIER_REQUEST_EXCLUSIONS: Array<SupplierRequestExclusion> = [];
let EXCLUDED_CONTRACT_STEPS: Array<ExcludedContractStep> = [];
let PLANNED_SIGN_INSTALLATION_DEFAULTS: Array<PlannedSignInstallationDefault> = [];
let CONTRACT_CONFIGURATIONS:Array<ContractConfiguration> = [];

let FIELD_CONFIGURATIONS: Array<FieldConfiguration> = [];
let DISTRICTS: Array<District> = [];

let mainVar: MainVar = null;

export async function ForceAllDropDownList() {
    TYPE_OF_PROPOSAL_LIST = await General.GetDropDownItemList(SOURCE.TYPE_OF_PROPOSAL);
    DISTRIBUTOR_LIST = await General.GetDropDownItemList(SOURCE.DISTRIBUTOR);
    WORKSHOP_AREA_LIST = await General.GetDropDownItemList(SOURCE.WORKSHOP_AREA);
    TRAFFIC_FLOW_LIST = await General.GetDropDownItemList(SOURCE.TRAFFIC_FLOW);
    WORKSHOP_VISIBILITY_LIST = await General.GetDropDownItemList(SOURCE.WORKSHOP_VISIBILITY);
    WORKSHOP_APPEARANCE_LIST = await General.GetDropDownItemList(SOURCE.WORKSHOP_APPEARANCE);
    TRAINING_TYPE_LIST = await General.GetDropDownItemList(SOURCE.TRAINING_TYPE);
    TRAINING_PERYEAR_LIST = await General.GetDropDownItemList(SOURCE.TRAINING_PERYEAR);
    CONSUMER_REVIEW_LIST = await General.GetDropDownItemList(SOURCE.CONSUMER_REVIEW);
    SERVICE_LIST = await General.GetDropDownItemList(SOURCE.SERVICE);
    FINANCIAL_RISK_LIST = await General.GetDropDownItemList(SOURCE.FINANCIAL_RISK);
    SIGN_CUSTOMIZATION_LIST = await General.GetDropDownItemList(SOURCE.SIGN_CUSTOMIZATION);
    SIGN_TYPE_LIST = await General.GetDropDownItemList(SOURCE.SIGN_TYPE);
    SIGN_SIZE_LIST = await General.GetDropDownItemList(SOURCE.SIGN_SIZE);
    SIGN_BRAND_CUSTOMIZATION_LIST = await General.GetDropDownItemList(SOURCE.SIGN_BRAND_CUSTOMIZATION);
    SIGN_HIGH_TRAFFIC_STREET_LIST = await General.GetDropDownItemList(SOURCE.SIGN_HIGH_TRAFFIC_STREET);
    SIGN_REPLACEMENT_TYPE_LIST = await General.GetDropDownItemList(SOURCE.SIGN_REPLACEMENT_TYPE);
    WELCOME_KIT_SIZE_LIST = await General.GetDropDownItemList(SOURCE.WELCOME_KIT_SIZE);

    DD_SIGN_REPLACEMENT_MODULES_PANELS = await General.GetDropDownItemList(SOURCE.SIGN_REPLACEMENT_MODULES_PANELS);
    DD_SIGN_REPLACEMENT_MODULES_PLEXIGLASS = await General.GetDropDownItemList(SOURCE.SIGN_REPLACEMENT_MODULES_PLEXIGLASS);

    EXCLUDED_TYPE_OF_PROPOSAL_OPTIONS = await GetExcludedTypeOfProposalOptions();
    POTENTIAL_VOLUME_LIMIT_OPTIONS = await GetPotentialVolumeLimitOptions();
    SUPPLIER_REQUEST_EXCLUSIONS = await GetSupplierRequestExclusions();
    EXCLUDED_CONTRACT_STEPS = await InitExcludedContractSteps();
    PLANNED_SIGN_INSTALLATION_DEFAULTS = await InitPlannedSignInstallationDefaults();
    CONTRACT_CONFIGURATIONS = await InitContractConfigurations();

    FIELD_CONFIGURATIONS = await InitFieldConfiguration();

    DISTRICTS = await InitDistricts();
}

export async function GetDropDownChildReplacementSign(idDropDownFather: string) {
    let mergedArray: Array<DropDownItem> = [];

    await SyncNet20Dropdowns();

    mergedArray = DD_SIGN_REPLACEMENT_MODULES_PANELS.concat(DD_SIGN_REPLACEMENT_MODULES_PLEXIGLASS);

    return General.SetOptionsDropDown(mergedArray.filter(x => x.idDropDownFather === idDropDownFather), false);
}

export async function SyncNet20Dropdowns() {    
    let firstLoad: boolean = false;
    if(mainVar == null) {
        mainVar = new MainVar();
        await mainVar.GetAsync();
        firstLoad = true;
    }
    
    if(firstLoad) {
        await ForceAllDropDownList();
    } else {
        let previousMainVar = new MainVar();
        previousMainVar.dropDownListLastUpdate = mainVar.dropDownListLastUpdate;
        previousMainVar.translationsLastUpdate = mainVar.translationsLastUpdate;
        previousMainVar.net20PotentialVolumeLimitsLastUpdate = mainVar.net20PotentialVolumeLimitsLastUpdate;
        previousMainVar.net20SupplierRequestExclusionsLastUpdate = mainVar.net20SupplierRequestExclusionsLastUpdate;
        previousMainVar.net20ExcludedContractStepsUpdate = mainVar.net20ExcludedContractStepsUpdate;
        previousMainVar.net20ExcludedContractStepsUpdate = mainVar.net20ExcludedContractStepsUpdate;
        previousMainVar.net20FieldConfigurationsUpdate = mainVar.net20FieldConfigurationsUpdate;
        previousMainVar.net20PlannedSignInstallationDefaultsUpdate = mainVar.net20PlannedSignInstallationDefaultsUpdate;
        previousMainVar.lastEndpointCheck = mainVar.lastEndpointCheck;

        await mainVar.GetAsync();
        if(mainVar.IsRecent(previousMainVar)) {    
            await ForceAllDropDownList();
        }
    }
}

async function GetExcludedTypeOfProposalOptions(): Promise<ExcludedTypeOfProposalOption[]> {
    let excludedOptions = new Array<ExcludedTypeOfProposalOption>();

    try{
        let response = await axios.get<ExcludedTypeOfProposalOption[]>(
            General.GetApiUrl('/api/net20/GetExcludedTypeOfProposalOptions'),{
            responseType: "json",
            withCredentials: true
        });  
    
        excludedOptions = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return excludedOptions;
}

async function GetPotentialVolumeLimitOptions(): Promise<PotentialVolumeLimitOption[]> {
    let potentialVolumeLimits = new Array<PotentialVolumeLimitOption>();

    try{
        let response = await axios.get<PotentialVolumeLimitOption[]>(
            General.GetApiUrl('/api/net20/GetPotentialVolumeLimitOptions'),{
            responseType: "json",
            withCredentials: true
        });  
    
        potentialVolumeLimits = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return potentialVolumeLimits;
}

async function GetSupplierRequestExclusions(): Promise<SupplierRequestExclusion[]> {
    let supplierRequestExclusions = new Array<SupplierRequestExclusion>();

    try{
        let response = await axios.get<SupplierRequestExclusion[]>(
            General.GetApiUrl('/api/net20/GetSupplierRequestExclusions'),{
            responseType: "json",
            withCredentials: true
        });  
    
        supplierRequestExclusions = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return supplierRequestExclusions;
}

function FilterExcludedTypeOfProposalOptions(selectedOptions: Array<SelectDropDownItem>, idCountry: string = null, idChannel: number = null): Array<SelectDropDownItem> {
    let filteredOptions: Array<SelectDropDownItem> = [];
    if(EXCLUDED_TYPE_OF_PROPOSAL_OPTIONS != null) {
        let excludedOptions = EXCLUDED_TYPE_OF_PROPOSAL_OPTIONS.filter(d => d.idCountry === idCountry && d.idChannel == idChannel);
        filteredOptions = selectedOptions.filter(s => excludedOptions.findIndex(e => e.typeOfProposal === s.value) == -1);

        return filteredOptions;
    } else {
        return selectedOptions;
    }
}

export async function GetDropDownListBySource(source:string, selectedValue: string = null, idCountry: string = null, idChannel: number = null): Promise<SelectDropDownItem[]> {
    let selectOptions: Array<SelectDropDownItem> = [];

    await SyncNet20Dropdowns();

    switch(source) {
        case SOURCE.TYPE_OF_PROPOSAL: {
            selectOptions = General.SetOptionsDropDown(TYPE_OF_PROPOSAL_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            selectOptions = FilterExcludedTypeOfProposalOptions(selectOptions, idCountry, idChannel);
            break;
        }
        case SOURCE.DISTRIBUTOR: {
            selectOptions = General.SetOptionsDropDown(DISTRIBUTOR_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.WORKSHOP_AREA: {
            selectOptions = General.SetOptionsDropDown(WORKSHOP_AREA_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.TRAFFIC_FLOW: {
            selectOptions = General.SetOptionsDropDown(TRAFFIC_FLOW_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.WORKSHOP_VISIBILITY: {
            selectOptions = General.SetOptionsDropDown(WORKSHOP_VISIBILITY_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)))
            break;
        }
        case SOURCE.WORKSHOP_APPEARANCE: {
            selectOptions = General.SetOptionsDropDown(WORKSHOP_APPEARANCE_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.TRAINING_TYPE: {
            selectOptions = General.SetOptionsDropDown(TRAINING_TYPE_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.TRAINING_PERYEAR: {
            selectOptions = General.SetOptionsDropDown(TRAINING_PERYEAR_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.CONSUMER_REVIEW: {
            selectOptions = General.SetOptionsDropDown(CONSUMER_REVIEW_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.SERVICE: {
            selectOptions = General.SetOptionsDropDown(SERVICE_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.FINANCIAL_RISK: {
            selectOptions = General.SetOptionsDropDown(FINANCIAL_RISK_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.SIGN_CUSTOMIZATION: {
            selectOptions = General.SetOptionsDropDown(SIGN_CUSTOMIZATION_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.SIGN_TYPE: {
            selectOptions = General.SetOptionsDropDown(SIGN_TYPE_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.SIGN_SIZE: {
            selectOptions = General.SetOptionsDropDown(SIGN_SIZE_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.SIGN_BRAND_CUSTOMIZATION: {
            selectOptions = General.SetOptionsDropDown(SIGN_BRAND_CUSTOMIZATION_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.SIGN_HIGH_TRAFFIC_STREET: {
            selectOptions = General.SetOptionsDropDown(SIGN_HIGH_TRAFFIC_STREET_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.SIGN_REPLACEMENT_TYPE: {
            selectOptions = General.SetOptionsDropDown(SIGN_REPLACEMENT_TYPE_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
        case SOURCE.WELCOME_KIT_SIZE: {
            selectOptions = General.SetOptionsDropDown(WELCOME_KIT_SIZE_LIST.filter(d => d.deletionDate == null || (d.deletionDate != null && d.idDropDownItem === selectedValue)));
            break;
        }
    }

    return selectOptions;
}

export async function IsPotentialVolumeCompliant(idCountry: string, idChannel: number, typeOfProposal: string, potentialVolume: number): Promise<boolean> {
    await SyncNet20Dropdowns();
    
    if(POTENTIAL_VOLUME_LIMIT_OPTIONS != null) {
        let limit =  POTENTIAL_VOLUME_LIMIT_OPTIONS.find(l => l.idCountry === idCountry
            && l.idChannel == idChannel
            && l.typeOfProposal === typeOfProposal)

        if(limit == null) {
            return true;
        } else {
            return potentialVolume >= limit.minVolume;
        }           
    } else {
        return true;
    }                   
}

export async function IsExcludedSupplierRequest(idCountry: string, idChannel: number, typeOfProposal: string): Promise<boolean> {
    await SyncNet20Dropdowns();

    if(SUPPLIER_REQUEST_EXCLUSIONS != null) {
        if(SUPPLIER_REQUEST_EXCLUSIONS.findIndex(s => s.typeOfProposal === typeOfProposal && s.idCountry == null && s.idChannel == null) >= 0
            || SUPPLIER_REQUEST_EXCLUSIONS.findIndex(s => s.typeOfProposal == null && s.idCountry === idCountry && s.idChannel == null) >= 0
            || SUPPLIER_REQUEST_EXCLUSIONS.findIndex(s => s.typeOfProposal == null && s.idCountry == null && s.idChannel == idChannel) >= 0
            || SUPPLIER_REQUEST_EXCLUSIONS.findIndex(s => s.typeOfProposal === typeOfProposal && s.idCountry === idCountry && s.idChannel == null) >= 0
            || SUPPLIER_REQUEST_EXCLUSIONS.findIndex(s => s.typeOfProposal === typeOfProposal && s.idCountry == null && s.idChannel == idChannel) >= 0
            || SUPPLIER_REQUEST_EXCLUSIONS.findIndex(s => s.typeOfProposal == null && s.idCountry === idCountry && s.idChannel == idChannel) >= 0
            || SUPPLIER_REQUEST_EXCLUSIONS.findIndex(s => s.typeOfProposal === typeOfProposal && s.idCountry === idCountry && s.idChannel == idChannel) >= 0) 
            return true;
        
        return false;
    }

    return false;
}                   

export async function GetExcludedContractSteps(idCountry = null) : Promise<ExcludedContractStep[]> {
    await SyncNet20Dropdowns();
    let excludedContractStep = new Array<ExcludedContractStep>();

    if(EXCLUDED_CONTRACT_STEPS != null) {
        excludedContractStep = EXCLUDED_CONTRACT_STEPS.filter(x => idCountry == null || x.idCountry === idCountry);
    }
    return excludedContractStep;
}

async function InitExcludedContractSteps(): Promise<ExcludedContractStep[]> {
    let excludedOptions = new Array<ExcludedContractStep>();

    try{
        let response = await axios.get<ExcludedContractStep[]>(
            General.GetApiUrl('/api/net20/GetExcludedContractSteps'),{
            responseType: "json",
            withCredentials: true
        });  
    
        excludedOptions = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return excludedOptions;
}                

export async function GetPlannedSignInstallationDefaults(idCountry: string = null, idChannel: number = null, typeOfProposal: string = null) : Promise<boolean> {
    await SyncNet20Dropdowns();
    let plannedSignInstallationDefault = null;
    let arrayDefaults = Array<PlannedSignInstallationDefault>();

    if(PLANNED_SIGN_INSTALLATION_DEFAULTS != null) {
       arrayDefaults = PLANNED_SIGN_INSTALLATION_DEFAULTS.filter(x => (x.idCountry == null || (x.idCountry != null && x.idCountry === idCountry))
                                                                        && (x.idChannel == null || (x.idChannel != null && x.idChannel == idChannel))
                                                                        && (x.typeOfProposal == null || x.typeOfProposal != null && x.typeOfProposal === typeOfProposal));
        if(arrayDefaults != null && arrayDefaults.length > 0) {
            let index = arrayDefaults.findIndex( x => x. idCountry != null && x.idChannel == null && x.typeOfProposal == null);
            if(index < 0) {
                index = arrayDefaults.findIndex( x => x. idCountry == null && x.idChannel != null && x.typeOfProposal == null);
                if(index < 0) {
                    index = arrayDefaults.findIndex( x => x. idCountry == null && x.idChannel == null && x.typeOfProposal != null);
                    if(index < 0) {
                        index = arrayDefaults.findIndex( x => x. idCountry != null && x.idChannel != null && x.typeOfProposal == null);
                        if(index < 0) {
                            index = arrayDefaults.findIndex( x => x. idCountry == null && x.idChannel != null && x.typeOfProposal != null);
                            if(index < 0) {
                                index = arrayDefaults.findIndex( x => x. idCountry != null && x.idChannel == null && x.typeOfProposal != null);
                                if(index < 0) {
                                    index = arrayDefaults.findIndex( x => x. idCountry != null && x.idChannel != null && x.typeOfProposal != null);
                                }
                            }
                        }
                    }
                }
            }
            plannedSignInstallationDefault = arrayDefaults[index].plannedSignInstallation;
        }
    }
    return plannedSignInstallationDefault;
}

async function InitPlannedSignInstallationDefaults(): Promise<PlannedSignInstallationDefault[]> {
    let plannedSignInstallationDefaults = new Array<PlannedSignInstallationDefault>();

    try{
        let response = await axios.get<PlannedSignInstallationDefault[]>(
            General.GetApiUrl('/api/net20/GetPlannedSignInstallationDefaults'),{
            responseType: "json",
            withCredentials: true
        });  
    
        plannedSignInstallationDefaults = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return plannedSignInstallationDefaults;
}

export async function GetFieldConfigurations(idCountry = null) : Promise<FieldConfiguration[]> {
    await SyncNet20Dropdowns();
    let fieldConfigurations = new Array<FieldConfiguration>();

    if(FIELD_CONFIGURATIONS != null) {
        fieldConfigurations = FIELD_CONFIGURATIONS.filter(x => x.idCountry == null || (x.idCountry != null && x.idCountry === idCountry));
    }
    return fieldConfigurations;
}

export function IsMandatoryField(fieldConfigurations: Array<FieldConfiguration>, field: string, idCountry: string = null) {
    var check = true;
    if(fieldConfigurations != null && fieldConfigurations.length > 0 && field != null) {
        var fieldConfigurationFiltered = fieldConfigurations.filter(x => x.entityProperty.toLowerCase() === field.toLowerCase());
        var fieldConfiguration = fieldConfigurationFiltered.find(x => x.idCountry == null);

        if(fieldConfiguration == null)
            fieldConfiguration = fieldConfigurationFiltered.find(x => x.idCountry != null && idCountry != null && x.idCountry === idCountry);

        if(fieldConfiguration != null && !fieldConfiguration.mandatory)
            check = false;
    }

    return check;
}

export async function GetDistricts(idCountry) : Promise<SelectDropDownItem[]> {
    await SyncNet20Dropdowns();
    let districts = new Array<District>();
    let dropDownItems = new Array<SelectDropDownItem>();

    if(DISTRICTS != null) {
        districts = DISTRICTS.filter(x => x.countryDivision.idCountry === idCountry).sort((a, b) => {
            const regionCompare = a.countryDivision.name.localeCompare(b.countryDivision.name)
            if(regionCompare !== 0)
                return regionCompare;
            return a.name.localeCompare(b.name);
        });
        districts.forEach(element => {
            let dropDownItem: SelectDropDownItem = {
                value: element.id,
                text:`${element.countryDivision.name} - ${element.name} (${element.code})`,
                identifyCode: null,
                deletionDate: null
            };

            dropDownItems.push(dropDownItem);
        });
    }
    return dropDownItems;
}

export async function GetContractConfiguration(idCountry: string) {
    await SyncNet20Dropdowns();
    let contractConfigurations = new ContractConfiguration();

    if(CONTRACT_CONFIGURATIONS != null)
        contractConfigurations = CONTRACT_CONFIGURATIONS.filter(x => x.idCountry === idCountry)[0];

    return contractConfigurations;
}

async function InitFieldConfiguration(): Promise<FieldConfiguration[]> {
    let fieldConfigurations = new Array<FieldConfiguration>();

    try{
        let response = await axios.get<FieldConfiguration[]>(
            General.GetApiUrl('/api/net20/GetFieldConfigurations'),{
            responseType: "json",
            withCredentials: true
        });  
    
        fieldConfigurations = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return fieldConfigurations;
}

async function InitDistricts(): Promise<District[]> {
    let districts = new Array<District>();

    try{
        let response = await axios.get<District[]>(
            General.GetApiUrl('/api/net20/GetDistricts'),{
            responseType: "json",
            withCredentials: true
        });  
    
        districts = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return districts;
}

async function InitContractConfigurations(): Promise<ContractConfiguration[]> {
    let contractConfigurations = new Array<ContractConfiguration>();

    try{
        let response = await axios.get<ContractConfiguration[]>(
            General.GetApiUrl('/api/net20/GetContractConfigurations'),{
            responseType: "json",
            withCredentials: true
        });  
    
        contractConfigurations = response.data;
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }

    return contractConfigurations;
}

